import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotificationService, NotificationItem } from '../notifications/notification.service';
import { Subscription } from 'rxjs';

interface ToastItem extends NotificationItem {
  id: number;
}

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.css']
})
export class ToastsComponent implements OnInit, OnDestroy {
  toasts: ToastItem[] = [];
  private sub: Subscription;
  private nextId = 1;
  private lastCount = 0;
  private timeoutMs = 4000;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.lastCount = this.notificationService.notifications.length;
    this.sub = this.notificationService.notifications$.subscribe(arr => {
      const newCount = arr.length;
      if (newCount > this.lastCount) {
        // New items are inserted at the front of the notifications array
        const added = arr.slice(0, newCount - this.lastCount);
        // Show newest first
        added.forEach(item => this.showToast(item));
      }
      this.lastCount = newCount;
    });
  }

  showToast(item: NotificationItem) {
    const toast: ToastItem = { ...item, id: this.nextId++ };
    this.toasts.unshift(toast);
    setTimeout(() => this.removeToast(toast.id), this.timeoutMs);
  }

  removeToast(id: number) {
    const idx = this.toasts.findIndex(t => t.id === id);
    if (idx !== -1) { this.toasts.splice(idx, 1); }
  }

  ngOnDestroy(): void {
    if (this.sub) { this.sub.unsubscribe(); }
  }
}
